import { keepAlive } from './keepAlive';

export interface IAuth {
  keepAlive: typeof keepAlive;
}

/**
 * @namespace
 */
const Auth: IAuth = {
  keepAlive,
};

export default Auth;
